import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export const EMPTY_STATE_MODE_MESSAGE = "message";
export const EMPTY_STATE_MODE_COMPONENT = "component";

// Which empty state a feed shows. Only ONE of the two settings ever renders, so
// the inspector shows only the chosen one — two always-editable fields where one
// silently loses is how an author ends up with a message that never appears.
export default class EmptyStateMode extends BaseOption {
  static userInterfaceComponent = {
    label: "Show",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Message",
          value: EMPTY_STATE_MODE_MESSAGE,
        },
        {
          label: "Component",
          value: EMPTY_STATE_MODE_COMPONENT,
        },
      ],
    },
  };

  // Existing feeds have no stored mode and must keep rendering their text.
  static defaultValue = EMPTY_STATE_MODE_MESSAGE;
}
